import React from 'react';
import { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Typography,
  Box
} from '@mui/material';
import SecurityIcon from '@mui/icons-material/Security';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { postSettingToggle } from 'src/ApiServices';

const handleContineApiClick = () => {};

const Enable2FAModal = ({ open, onClose, onEnable, onSkip, loading = false, token }) => {
  const [isEnabling, setIsEnabling] = useState(false);
  const isSmallMobile = window.innerWidth < 600;

  const handleContinue = async () => {
    setIsEnabling(true);
    try {
      const response = await postSettingToggle({ is_auth: 1, is_mail: 1 }, token);
      console.log('API Response:', response);

      // If response is okay
      if (response && (response.status === 200 || response.data?.success)) {
        console.log('API Success, calling onEnable...');
        if (onEnable) {
          onEnable(); // This should open the next modal
        } else {
          console.error('onEnable prop is not defined!');
        }
      }
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setIsEnabling(false);
    }
  };
  const handleSkip = () => {
    if (onSkip) {
      onSkip();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: 2,
          padding: 1,
          width: isSmallMobile ? '95%' : 'auto',
          m: isSmallMobile ? 1 : 0,
          maxWidth: isSmallMobile ? 'none' : 500
        }
      }}
    >
      <DialogTitle
        sx={{
          textAlign: 'center',
          py: 3,
          px: isSmallMobile ? 2 : 3
        }}
      >
        <SecurityIcon
          sx={{
            fontSize: isSmallMobile ? 50 : 60,
            color: 'warning.main',
            mb: 2
          }}
        />

        <Typography
          variant="h6"
          sx={{
            fontFamily: 'poppinsSemiBold',
            color: 'text.primary',
            fontSize: isSmallMobile ? '1.1rem' : '1.25rem'
          }}
        >
          Two-Factor Authentication
        </Typography>
      </DialogTitle>

      <DialogContent
        sx={{
          textAlign: 'center',
          pb: 2,
          px: isSmallMobile ? 2 : 3
        }}
      >
        <Box
          sx={{
            backgroundColor: 'whitesmoke',
            borderRadius: 1,
            p: 2,
            mb: 3,
            display: 'flex',
            alignItems: 'flex-start',
            gap: 1.5
          }}
        >
          <WarningAmberIcon
            sx={{
              color: 'warning.main',
              fontSize: 20,
              mt: 0.5
            }}
          />

          <Typography
            sx={{
              color: 'warning.dark',
              fontFamily: 'poppinsMedium',
              fontSize: isSmallMobile ? '0.9rem' : '0.95rem',
              textAlign: 'left'
            }}
          >
            <strong>2FA is currently OFF.</strong> Your account is less secure without two-factor
            authentication.
          </Typography>
        </Box>

        <DialogContentText
          sx={{
            color: 'text.secondary',
            fontFamily: 'poppinsRegular',
            fontSize: isSmallMobile ? '0.9rem' : '1rem',
            mb: 3,
            textAlign: 'left'
          }}
        >
          Two-factor authentication adds an extra layer of security to your account. You'll need to
          enter a verification code from your authenticator app when logging in.
        </DialogContentText>

        <Box
          sx={{
            backgroundColor: 'action.selected',
            borderRadius: 1,
            p: 2.5,
            textAlign: 'left'
          }}
        >
          <Typography
            sx={{
              color: 'text.primary',
              fontFamily: 'poppinsMedium',
              fontSize: isSmallMobile ? '0.67rem' : '1rem',
              mb: 1.5,
              display: 'flex',
              alignItems: 'center',
              gap: 1
            }}
          >
            <Box
              sx={{
                width: 8,
                height: 8,
                borderRadius: '50%',
                backgroundColor: 'primary.main'
              }}
            />
            <strong>Continue</strong> → Turn ON Two Step Verification
          </Typography>

          <Typography
            sx={{
              color: 'text.primary',
              fontFamily: 'poppinsMedium',
              fontSize: isSmallMobile ? '0.7rem' : '1rem',
              display: 'flex',
              alignItems: 'center',
              gap: 1
            }}
          >
            <Box
              sx={{
                width: 8,
                height: 8,
                borderRadius: '50%',
                backgroundColor: 'text.secondary'
              }}
            />
            <strong>Skip</strong> → Keep Two Step Verification OFF
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions
        sx={{
          justifyContent: 'end',
          gap: 2,
          pb: 3,
          px: isSmallMobile ? 2 : 3,
          flexDirection: isSmallMobile ? 'column' : 'row'
        }}
      >
        <Button
          onClick={handleSkip}
          variant="outlined"
          disabled={loading}
          fullWidth={isSmallMobile}
          sx={{
            minWidth: isSmallMobile ? 'auto' : 120,
            fontFamily: 'poppinsMedium',
            color: 'text.secondary',
            borderColor: 'text.secondary',
            '&:hover': {
              borderColor: 'text.secondary',
              backgroundColor: 'action.hover'
            }
          }}
        >
          Skip
        </Button>

        <Button
          onClick={handleContinue}
          variant="contained"
          disabled={loading || isEnabling}
          fullWidth={isSmallMobile}
          sx={{
            minWidth: isSmallMobile ? 'auto' : 120,
            fontFamily: 'poppinsMedium',
            backgroundColor: 'warning.main',
            '&:hover': {
              backgroundColor: 'warning.dark'
            }
          }}
        >
          {isEnabling ? 'Enabling...' : loading ? 'Loading...' : 'Continue'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default Enable2FAModal;
